module.exports = __webpack_public_path__ + "img/suit_jacket.8b9d7207.jpg";